import React, {useMemo} from 'react';
import {Container,} from '@mui/material';
import {Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

const PersonalityFacetsChart = ({ results }) => {

  const truncated = useMemo(() => !Array.isArray(results) ? [] : results.map(r => ({...r, percentage: r.percentage.toFixed(2)})).sort((a,b) => b.percentage - a.percentage), [results])
  if(!Array.isArray(results)){
    return null;
  }
  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      <Container style={{padding: "0 3em 0 1.5em"}}>
        <ResponsiveContainer width="100%" height={(results.length * (18 + 2)) + 40}>
          <BarChart layout="vertical" data={truncated} barCategoryGap={1}>
            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis tick={{fontSize: "10px"}} hide={false}  type="number" domain={[0, 100]}/>
            <YAxis hide={true} dataKey="name" type="category"/>
            <Tooltip/>
            {/*<Legend />*/}
            <Bar dataKey="percentage" fill="#ef8354" >
              <LabelList dataKey="name" position="insideLeft" fill={"#fff"} style={{fontSize: "0.85rem", fontWeight: 600, color: "#fff"}} />
              <LabelList dataKey="percentage" position="right" style={{fontSize: "0.7225rem"}} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Container>
    </div>
  )
}

export default PersonalityFacetsChart